import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="banner-preview"
export default class extends Controller {
	static targets = ["file", "preview", "placeholder"];

	connect() {
		this.fileTarget.addEventListener("change", this.loadFile.bind(this));
	}

	loadFile(event) {
		if (event.target.files.length === 0) {
			return;
		}

		const reader = new FileReader();
		reader.onload = () => {
			this.previewTarget.src = reader.result;
			this.previewTarget.classList.remove("hidden");
			if (this.hasPlaceholderTarget) {
				this.placeholderTarget.classList.add("hidden");
			}
		};
		reader.readAsDataURL(event.target.files[0]);
	}
}
